import { css } from '@backyard-ui/styles';

const styles = css({
  display: 'inline-flex',

  alignItems: 'center',
  justifyContent: 'center',

  width: 'auto',
  height: 'auto',

  fontWeight: '$semibold',
  textDecoration: 'none',
  lineHeight: 1,

  appearance: 'none',
  cursor: 'pointer',
  userSelect: 'none',

  border: 0,
  borderRadius: '$md',

  outline: 'none',

  transitionProperty:
    'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
  transitionDuration: '200ms',

  '&:disabled, &[disabled]': {
    color: '$n300 !important',

    cursor: 'not-allowed',
    boxShadow: 'none !important',
  },

  '.Button-icon': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '.Button-icon--left': {
    display: 'inline-flex',
    alignSelf: 'center',
    marginRight: '$2',
  },
  '.Button-icon--right': {
    display: 'inline-flex',
    alignSelf: 'center',
    marginLeft: '$2',
  },
  variants: {
    size: {
      xs: {
        height: '$7',
        paddingX: '$3',
        fontSize: '$tsm',

        '.Button-icon': {
          width: '$3',
          height: '$3',
        },
      },
      sm: {
        height: '$10',
        paddingX: '$4',
        fontSize: '$tlg',

        '.Button-icon': {
          width: '$4',
          height: '$4',
        },
      },
      md: {
        height: '$12',
        paddingX: '$6',
        fontSize: '$txl',

        '.Button-icon': {
          width: '$5',
          height: '$5',
        },
      },
    },
    appearance: {
      critical: {
        color: '$white',
        background: '$c600',

        '&:active': {
          borderColor: '$c300',
          background: '$c800',
        },

        '&:focus': {
          borderColor: '$c300',
          focus: '$c300',
        },

        '&:hover': {
          background: '$c700',
        },
      },
      info: {
        color: '$white',
        background: '$i600',

        '&:active': {
          borderColor: '$i300',
          background: '$i800',
        },

        '&:focus': {
          borderColor: '$i300',
          focus: '$i300',
        },

        '&:hover': {
          background: '$i700',
        },
      },
      primary: {
        color: '$white',
        background: '$p600',

        '&:active': {
          borderColor: '$p300',
          background: '$p800',
        },

        '&:focus': {
          borderColor: '$p300',
          focus: '$p300',
        },

        '&:hover': {
          background: '$p700',
        },
      },
      secondary: {
        color: '$white',
        background: '$s600',

        '&:active': {
          borderColor: '$s300',
          background: '$s800',
        },

        '&:focus': {
          borderColor: '$s300',
          focus: '$s300',
        },

        '&:hover': {
          background: '$s700',
        },
      },
      warning: {
        color: '$n900',
        background: '$w400',

        '&:active': {
          borderColor: '$w500',
          background: '$w600',
        },

        '&:focus': {
          borderColor: '$w500',
          focus: '$w300',
        },

        '&:hover': {
          background: '$w500',
        },
      },
    },
    variant: {
      ghost: {
        '&:disabled, &[disabled]': {
          background: 'transparent',
        },
      },
      outline: {
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderWidth: '$xs',
        // NOTE:
        // This doesn't work yet
        // ISSUE: https://github.com/modulz/stitches/issues/913
        // background: 'transparent',
        '&:disabled, &[disabled]': {
          borderColor: '$n300 !important',
          background: '$n100 !important',
        },
      },
      solid: {
        '&:disabled, &[disabled]': {
          background: '$n100 !important',
        },
      },
    },
    isFullWidth: {
      true: {
        width: '100%',
      },
    },
  },
  compoundVariants: [
    {
      appearance: 'critical',
      variant: 'ghost',
      css: {
        color: '$c600',
        background: 'transparent',

        '&:active': {
          background: '$c200',
        },

        '&:focus': {
          focus: '$c300',
        },

        '&:hover': {
          background: '$c100',
        },
      },
    },
    {
      appearance: 'info',
      variant: 'ghost',
      css: {
        color: '$i600',
        background: 'transparent',

        '&:active': {
          background: '$i200',
        },

        '&:focus': {
          focus: '$i300',
        },

        '&:hover': {
          background: '$i100',
        },
      },
    },
    {
      appearance: 'primary',
      variant: 'ghost',
      css: {
        color: '$p600',
        background: 'transparent',

        '&:active': {
          background: '$p200',
        },

        '&:focus': {
          focus: '$p300',
        },

        '&:hover': {
          background: '$p100',
        },
      },
    },
    {
      appearance: 'secondary',
      variant: 'ghost',
      css: {
        color: '$s600',
        background: 'transparent',

        '&:active': {
          background: '$s200',
        },

        '&:focus': {
          focus: '$s300',
        },

        '&:hover': {
          background: '$s100',
        },
      },
    },
    {
      appearance: 'warning',
      variant: 'ghost',
      css: {
        background: 'transparent',

        '&:active': {
          background: '$w200',
        },

        '&:focus': {
          focus: '$w300',
        },

        '&:hover': {
          background: '$w100',
        },
      },
    },
    {
      appearance: 'critical',
      variant: 'outline',
      css: {
        color: '$c600',
        borderColor: '$c600',
        background: 'transparent',

        '&:active': {
          borderColor: '$c500',
          background: '$c200',
        },

        '&:focus': {
          borderColor: '$c500',
          focus: '$c300',
        },

        '&:hover': {
          background: '$c100',
        },
      },
    },
    {
      appearance: 'info',
      variant: 'outline',
      css: {
        color: '$i600',
        borderColor: '$i600',
        background: 'transparent',

        '&:active': {
          borderColor: '$i500',
          background: '$i200',
        },

        '&:focus': {
          borderColor: '$i500',
          focus: '$i300',
        },

        '&:hover': {
          background: '$i100',
        },
      },
    },
    {
      appearance: 'primary',
      variant: 'outline',
      css: {
        color: '$p600',
        borderColor: '$p600',
        background: 'transparent',

        '&:active': {
          borderColor: '$p500',
          background: '$p200',
        },

        '&:focus': {
          borderColor: '$p500',
          focus: '$p300',
        },

        '&:hover': {
          background: '$p100',
        },
      },
    },
    {
      appearance: 'secondary',
      variant: 'outline',
      css: {
        color: '$s600',
        borderColor: '$s600',
        background: 'transparent',

        '&:active': {
          borderColor: '$s500',
          background: '$s200',
        },

        '&:focus': {
          borderColor: '$s500',
          focus: '$s300',
        },

        '&:hover': {
          background: '$s100',
        },
      },
    },
    {
      appearance: 'warning',
      variant: 'outline',
      css: {
        borderColor: '$w500',
        background: 'transparent',

        '&:active': {
          borderColor: '$w600',
          background: '$w200',
        },

        '&:focus': {
          borderColor: '$w500',
          focus: '$w300',
        },

        '&:hover': {
          background: '$w100',
        },
      },
    },
  ],
  defaultVariants: {
    size: 'sm',
    appearance: 'primary',
    variant: 'solid',
  },
});

export default styles;
